import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "icon", "locationModal", "cityInput", "stateInput"]
  
  connect() {
    this.panelVisible = false
  }
  
  toggle() {
    this.panelVisible = !this.panelVisible
    
    if (this.panelVisible) {
      this.panelTarget.style.display = 'block'
      this.iconTarget.classList.add('fa-times')
      this.iconTarget.classList.remove('fa-cog')
    } else {
      this.panelTarget.style.display = 'none'
      this.iconTarget.classList.add('fa-cog')
      this.iconTarget.classList.remove('fa-times')
    }
  }
  
  showLocationModal() {
    this.locationModalTarget.classList.remove('hidden')
    this.cityInputTarget.focus()
  }
  
  closeLocationModal(event) {
    // Only close if clicked on backdrop or close button
    if (event && event.target !== this.locationModalTarget) return
    
    this.locationModalTarget.classList.add('hidden')
    this.clearInputs()
  }
  
  stopPropagation(event) {
    event.stopPropagation()
  }
  
  saveManualLocation() {
    const city = this.cityInputTarget.value.trim()
    const state = this.stateInputTarget.value.trim()
    
    if (!city || !state) {
      this.showError('Please enter both city and state')
      return
    }
    
    // Geocode the location
    this.geocodeLocation(city, state)
  }
  
  async geocodeLocation(city, state) {
    const query = `${city}, ${state}`
    
    try {
      // Using a simple geocoding approach - you might want to use a proper service
      const response = await fetch(`https://api.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`)
      const data = await response.json()
      
      if (data.length > 0) {
        const location = data[0]
        const latitude = parseFloat(location.lat)
        const longitude = parseFloat(location.lon)
        
        // Update location on server
        await this.updateLocation(latitude, longitude, city, state)
      } else {
        this.showError('Location not found. Please check city and state.')
      }
    } catch (error) {
      console.error('Geocoding error:', error)
      this.showError('Failed to find location. Please try again.')
    }
  }
  
  async updateLocation(latitude, longitude, city, state) {
    try {
      const response = await fetch('/chat/update_location', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          latitude: latitude,
          longitude: longitude,
          city: city,
          state: state
        })
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.showSuccess(`Location set to: ${data.location}`)
        this.closeLocationModal()
        
        // Update the location display in the UI
        const locationController = this.application.getControllerForElementAndIdentifier(
          document.querySelector('[data-controller*="location"]'), 
          "location"
        )
        if (locationController) {
          locationController.updateLocationDisplay(data.location)
        }
      } else {
        this.showError(data.error || 'Failed to update location')
      }
    } catch (error) {
      console.error('Location update error:', error)
      this.showError('Failed to save location')
    }
  }
  
  clearInputs() {
    this.cityInputTarget.value = ''
    this.stateInputTarget.value = ''
  }
  
  showSuccess(message) {
    this.showMessage(message, 'success')
  }
  
  showError(message) {
    this.showMessage(message, 'error')
  }
  
  showMessage(message, type) {
    // Create toast notification
    const toast = document.createElement('div')
    const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500'
    
    toast.className = `fixed top-20 right-4 ${bgColor} text-white px-4 py-3 rounded-lg shadow-lg z-50 max-w-sm`
    toast.innerHTML = `
      <div class="flex items-center">
        <i class="fas fa-${type === 'success' ? 'check' : 'exclamation-triangle'} mr-2"></i>
        <span class="text-sm">${message}</span>
      </div>
    `
    
    document.body.appendChild(toast)
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      toast.remove()
    }, 5000)
  }
}